export const CONTACT_PHONE = '+78126650640';
export const CONTACT_PHONE_LABEL = '8 (812) 665-06-40';
export const CONTACT_EMAIL = 'info@gsp-p.ru';
export const CONTACT_MAX = '+79117519786';
